<template>
  <basic-dialog v-model="showDialog" max-width="800px">
    <template v-slot:title>{{ $t('language_selector.title') }}</template>
    <v-card-text class="white--text mt-6 mb-0">{{ $t('language_selector.subtitle') }}</v-card-text>
    <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" v-for="group in regionGroups" :key="group.region">
            <div class="text-h6 white--text text-uppercase">{{ $t(group.labelKey) }}</div>
            <v-radio-group v-model="selectedKey">
              <v-radio v-for="l in group.locales" :key="l.key" :value="l.key">
                <template v-slot:label>
                  <div>{{ $t('language_selector.lang.' + l.locale) }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
    </v-card-text>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="closeDialog">{{ $t('continue') }}</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from '@/components/BasicDialog.vue';
import { REGION_GROUPS, getActiveRegionKey, localeOf } from '@/config/regions';

export default {
  name: 'LanguageSelector',
  components: {
    BasicDialog
  },
  data() {
    return {
      showDialog: false,
      activeKey: getActiveRegionKey(),
    };
  },
  computed: {
    regionGroups() {
      return REGION_GROUPS;
    },
    selectedKey: {
      get() {
        return this.activeKey;
      },
      set(newKey) {
        this.activeKey = newKey;
        this.$i18n.locale = localeOf(newKey);
        try {
          localStorage.setItem('harvia-language', this.$i18n.locale);
          localStorage.setItem('harvia-region-key', newKey);
        } catch (e) { /* ignore */ }
      }
    }

  },
  mounted() {
    this.$root.$on('show-language-selector', () => {
      this.showDialog = true;
    });
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
      this.$emit('language-selected');
    }
  }
};
</script>

